function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.8125 2.0625C5.8125 2.78906 5.22656 3.375 4.5 3.375C3.77344 3.375 3.1875 2.78906 3.1875 2.0625C3.1875 1.33594 3.77344 0.75 4.5 0.75C5.22656 0.75 5.8125 1.33594 5.8125 2.0625ZM6.375 7.05469V13.5C6.375 13.9219 6.04688 14.25 5.625 14.25C5.20312 14.25 4.875 13.9219 4.875 13.5V9.75C4.875 9.53906 4.71094 9.375 4.5 9.375C4.28906 9.375 4.125 9.53906 4.125 9.75V13.5C4.125 13.9219 3.79688 14.25 3.375 14.25C2.95312 14.25 2.625 13.9219 2.625 13.5V7.05469L1.54688 8.50781C1.28906 8.83594 0.820312 8.90625 0.492188 8.67188C0.164062 8.41406 0.09375 7.94531 0.328125 7.61719L1.99219 5.39062C2.57812 4.59375 3.51562 4.125 4.5 4.125C5.48438 4.125 6.42188 4.59375 7.00781 5.39062L8.67188 7.61719C8.90625 7.94531 8.83594 8.41406 8.50781 8.67188C8.17969 8.90625 7.71094 8.83594 7.45312 8.50781L6.375 7.05469Z",
  fill: "#006CA3"
});

function SvgHuman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.d9be85d8.svg";
export { ForwardRef as ReactComponent };